import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'vsf-review-mode-banner',
    templateUrl: './review-mode-banner.component.html',
})
export class ReviewModeBannerComponent {
    dashboardUrl: string = (environment as any).apiHost + '/admin/' || 'https://app.dealomega.com/admin/';
}
